interface NovedadSistemaItemProps {
  titulo: string
  mensaje: string
}

/** Una novedad publicada tal como se ve en la tarjeta Novedades. La usa también la vista previa. */
export function NovedadSistemaItem({ titulo, mensaje }: NovedadSistemaItemProps) {
  return (
    <div className="text-sm">
      <p className="font-medium truncate">{titulo}</p>
      <p className="text-muted-foreground whitespace-pre-line break-words line-clamp-3">{mensaje}</p>
    </div>
  )
}
